import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Industries from './components/Industries';
import DealersPricing from './components/DealersPricing';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import EnterpriseSection from './components/EnterpriseSection';
import AdditionalServices from './components/AdditionalServices';
import Partners from './components/Partners';
import ActivationProcess from './components/ActivationProcess';
import DigitalServices from './components/DigitalServices';
import BlogPreview from './components/BlogPreview';
import FAQ from './components/FAQ';
import BookDemo from './components/BookDemo';
import FinalCTA from './components/FinalCTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import ScrollToTop from './components/ScrollToTop';
import ReadingProgress from './components/ReadingProgress';
import HomeSEO from './components/HomeSEO';
import ScrollRevealSection from '../../components/feature/ScrollRevealSection';

export default function Home() {
  return (
    <main className="bg-navy-950 min-h-screen overflow-x-hidden">
      <HomeSEO />
      <ReadingProgress />
      <Navbar />
      <Hero />

      <ScrollRevealSection delay={0}>
        <Services />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <Industries />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <Testimonials />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <DealersPricing />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <Pricing />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <EnterpriseSection />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <AdditionalServices />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <Partners />
      </ScrollRevealSection>

      <ScrollRevealSection delay={50}>
        <ActivationProcess />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <DigitalServices />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <BlogPreview />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <FAQ />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <BookDemo />
      </ScrollRevealSection>

      <ScrollRevealSection delay={50}>
        <FinalCTA />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <Contact />
      </ScrollRevealSection>

      <ScrollRevealSection delay={0}>
        <Footer />
      </ScrollRevealSection>

      <WhatsAppFloat />
      <ScrollToTop />
    </main>
  );
}
